import Container from "@mui/material/Container";
import Header from "../header/Header";
import AssessmentList from "./AssessmentList";

const Home = () => {

  return (
    <>
      <Container maxWidth="xl" style={{ padding: "0px" }}>
        <Header home="homepage"/>
        <AssessmentList />
      </Container>
    </>
  );
};

export default Home;
